import { Typography } from '@mui/material';

import { Labels } from '@/models/labels';
import { getTimeAgo } from '@/utils/datesAndTime';

import { PendingLabel } from '../types';

export const getInitials = (name: string): string => {
  const parts = name.trim().split('.');
  const first = parts[0];
  const last = parts[parts.length - 1];
  return `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase();
};

export const buildLabelText = (label: Labels.Details) => {
  if (!label.category)
    return <Typography component="span">{label.name}</Typography>;

  return (
    <Typography component="span">
      <Typography component="span" color="text.secondary">
        {label.category.name} /{' '}
      </Typography>
      {label.name}
    </Typography>
  );
};

export const buildPendingLabelText = ({ name, categoryName }: PendingLabel) => {
  if (!categoryName) return <Typography component="span">{name}</Typography>;

  return (
    <Typography component="span">
      <Typography component="span" color="text.secondary">
        {categoryName} /{' '}
      </Typography>
      {name}
    </Typography>
  );
};

export const buildTooltipText = (
  label: Labels.Details,
  isCurrentUser: boolean
): string => {
  const timeAgo = getTimeAgo(label.assignedAt);
  return isCurrentUser
    ? `Added By you, ${timeAgo}`
    : `Added by ${label.assignedBy.name ?? 'unknown'}, ${timeAgo}`;
};

export const formatBadge = (available: number, total: number) =>
  available === total ? `${total}` : `${available} of ${total}`;
